(() => {
  const root = document.querySelector('[data-lovalo-cookie-root]');
  const banner = root?.querySelector('[data-lovalo-cookie]');
  if (!root || !banner) return;

  const manageButton = root.querySelector('[data-lovalo-cookie-manage]');
  const acceptButton = banner.querySelector('[data-lovalo-cookie-accept]');
  const essentialButton = banner.querySelector('[data-lovalo-cookie-essential]');
  const customizeButton = banner.querySelector('[data-lovalo-cookie-customize]');
  const preferencesPanel = banner.querySelector('[data-lovalo-cookie-preferences]');
  const saveButton = banner.querySelector('[data-lovalo-cookie-save]');
  const status = banner.querySelector('[data-lovalo-cookie-status]');
  const checks = Object.fromEntries(Array.from(banner.querySelectorAll('[data-lovalo-cookie-pref]')).map((el) => [el.dataset.lovaloCookiePref, el]));

  const nativeBannerExists = () => Boolean(document.querySelector('#shopify-pc__banner, #shopify-pc__prefs, [id^="shopify-pc__"]'));
  const privacyApi = () => window.Shopify && window.Shopify.customerPrivacy;
  const announce = (message) => {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(() => { status.textContent = message; }, 20);
  };
  const setManageVisible = (visible) => { if (manageButton) manageButton.hidden = !visible; };
  const hide = ({ showManage = true } = {}) => {
    banner.hidden = true;
    banner.classList.remove('lovalo-cookie--busy');
    setManageVisible(showManage);
  };
  const show = ({ openPreferences = false } = {}) => {
    if (nativeBannerExists()) {
      hide({ showManage: false });
      return;
    }
    setManageVisible(false);
    banner.hidden = false;
    preferencesPanel.hidden = !openPreferences;
    customizeButton?.setAttribute('aria-expanded', String(openPreferences));
    syncCurrent();
    if (openPreferences) preferencesPanel.querySelector('input:not([disabled]), button')?.focus();
    else acceptButton?.focus();
  };
  const setBusy = (busy) => {
    banner.classList.toggle('lovalo-cookie--busy', busy);
    banner.querySelectorAll('button').forEach((button) => { button.disabled = busy; });
  };
  const setConsent = (choice) => {
    const api = privacyApi();
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    setBusy(true);
    api.setTrackingConsent(choice, () => {
      announce('העדפות הפרטיות נשמרו');
      window.setTimeout(() => hide({ showManage: true }), 120);
    });
  };
  function syncCurrent() {
    const api = privacyApi();
    if (!api || typeof api.currentVisitorConsent !== 'function') return;
    try {
      const current = api.currentVisitorConsent() || {};
      if (checks.preferences) checks.preferences.checked = current.preferences === 'yes' || current.preferences === true;
      if (checks.analytics) checks.analytics.checked = current.analytics === 'yes' || current.analytics === true;
      if (checks.marketing) checks.marketing.checked = current.marketing === 'yes' || current.marketing === true;
    } catch (_error) {}
  }

  acceptButton?.addEventListener('click', () => setConsent({ preferences: true, analytics: true, marketing: true }));
  essentialButton?.addEventListener('click', () => setConsent({ preferences: false, analytics: false, marketing: false }));
  customizeButton?.addEventListener('click', () => {
    const willOpen = preferencesPanel.hidden;
    preferencesPanel.hidden = !willOpen;
    customizeButton.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) {
      syncCurrent();
      preferencesPanel.querySelector('input:not([disabled]), button')?.focus();
    }
  });
  saveButton?.addEventListener('click', () => setConsent({
    preferences: Boolean(checks.preferences?.checked),
    analytics: Boolean(checks.analytics?.checked),
    marketing: Boolean(checks.marketing?.checked),
  }));
  manageButton?.addEventListener('click', () => show({ openPreferences: true }));

  const nativeWatcher = new MutationObserver(() => {
    if (nativeBannerExists()) hide({ showManage: false });
  });
  nativeWatcher.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const init = () => {
    attempts += 1;
    if (nativeBannerExists()) {
      hide({ showManage: false });
      return;
    }
    const api = privacyApi();
    if (!api) {
      if (attempts < 40) window.setTimeout(init, 150);
      return;
    }
    let shouldShow = false;
    try { shouldShow = typeof api.shouldShowBanner === 'function' ? api.shouldShowBanner() === true : false; } catch (_error) {}
    if (shouldShow) show();
    else {
      syncCurrent();
      hide({ showManage: true });
    }
  };

  init();
})();
